export default "__VITE_ASSET__Cb4GDi61__"